import LoginIcon from "@mui/icons-material/Login";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

import { PrimaryButton, SecondaryButton } from "@/components/common";

import { marketplaceTypography as mt } from "../constants/marketplaceTypography";

interface WooLoginPromptDialogProps {
  open: boolean;
  storeName: string;
  loading?: boolean;
  onClose: () => void;
  onLogin: () => void;
}

/** Primeira abertura da loja — associação/login OpenID Fluxmed no WordPress. */
export function WooLoginPromptDialog({
  open,
  storeName,
  loading = false,
  onClose,
  onLogin,
}: WooLoginPromptDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ ...mt.sectionTitle }}>Associar conta no dispensador</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5}>
          <Typography sx={{ ...mt.body, color: "text.secondary" }}>
            Para solicitar dispensação em <strong>{storeName}</strong>, é necessário
            associar sua conta Fluxmed. Um popup será aberto para login seguro.
          </Typography>
          <Typography sx={{ ...mt.bodySecondary, color: "text.secondary" }}>
            Após concluir o login, retornaremos automaticamente à dispensação.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <SecondaryButton width="fit-content" height="44px" onClick={onClose}>
          Cancelar
        </SecondaryButton>
        <PrimaryButton
          width="fit-content"
          height="44px"
          loading={loading}
          onClick={onLogin}
          startIcon={<LoginIcon />}
        >
          Associar / Entrar
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}
